import {ReportByWarehouseAndPartner} from "../models/Report";
import {ProductReceiveDailyReportTemplateData} from "./ProductReceiveDailyReportTemplateData";
import {ProductReceiveReportImportTemplate} from "./ProductReceiveDailyReportImportTemplate";
import {cloneDeep} from "lodash";

export const getProductReceiveDailyReportTemplate = (
    dataMercantile: ReportByWarehouseAndPartner[],
    dataRepromaterial: ReportByWarehouseAndPartner[],
    selectedWarehouse: string,
    selectedPartner: string,
    totalInputNeto: number,
    totalInputSrps: number,
    totalOutputNeto: number,
    totalOutputSrps: number
    ) => {
    return ProductReceiveReportImportTemplate(
        prepareData(
            dataMercantile,
            dataRepromaterial,
            selectedWarehouse,
            selectedPartner,
            totalInputNeto,
            totalInputSrps,
            totalOutputNeto,
            totalOutputSrps
        )
    );
};

const prepareData = (
    documentDataMercantile: ReportByWarehouseAndPartner[],
    documentDataRepromaterial: ReportByWarehouseAndPartner[],
    selectedWarehouse: string,
    selectedPartner: string,
    totalInputNeto: number,
    totalInputSrps: number,
    totalOutputNeto: number,
    totalOutputSrps: number
    ) => {
    const templateData: ProductReceiveDailyReportTemplateData = {
        partnerName: selectedPartner,
        warehouseName: selectedWarehouse ?? 'sve magacine',
        reportByDayMercantile: cloneDeep(documentDataMercantile),
        reportByDayRepromaterial: cloneDeep(documentDataRepromaterial),
        totalInputNeto,
        totalInputSrps,
        totalOutputNeto,
        totalOutputSrps
    };

    return templateData;
};